export default `
<div class="animated fadeIn">
<h2>1.</h2>
<table border='1' bordercolor='black' width='100%' height='250' align='center'>
	<tr>
		<th>프로젝트 명</th>
		<td>Node.js 게시판 & 채팅</td>
	</tr>
	<tr>
		<th>개발환경</th>
		<td>Node.js 10.15.3, express, pug, Mysql 5.7</td>
	</tr>
	<tr>
		<th>프로젝트 개요</th>
		<td>Express와 Pug를 사용한 RESTful 기반의 CRUD 게시판과 Socket.io를 사용한 실시간 채팅 프로젝트입니다.</td>
	</tr>
	<tr>
		<th>Git 주소</th>
		<td>
			<a href='https://github.com/a2175/NodeJSproject' target='_blank'>https://github.com/a2175/NodeJSproject</a>
		</td>
	</tr>
	<th>Demo</th>
		<td><a href='http://a2175.iptime.org:3001/'
			target='_blank'>http://a2175.iptime.org:3001/</a></td>
	</tr>
	<tr>
		<th colspan='2' align='center' bgcolor='#CCEEFF' height='20'>상세내용</th>
	</tr>
</table>

<table width='100%' height='1'>
<tr>
<td>

<img src='http://${window.location.hostname}/img/3-1.png' style='width: 50%; height: auto;'>
<img src='http://${window.location.hostname}/img/3-2.png' style='width: 90%; height: auto;'>
<img src='http://${window.location.hostname}/img/3-3.png' style='width: 70%; height: auto;'>

Express + Pug + Mysql를 사용한 RESTful 기반의 CRUD 게시판과 Socket.io를 사용하여 구축한 실시간 채팅 프로젝트입니다.

</td>
</tr>
</table>` +

/* ------------------------------------------------------------------------------------------ */

`
<br><br><br><br>
<h2>2.</h2>
<table border='1' bordercolor='black' width='100%' height='250' align='center'>
	<tr>
		<th>프로젝트 명</th>
		<td>React + Node.js 게시판</td>
	</tr>
	<tr>
		<th>개발환경</th>
		<td>Node.js 10.15.3, express, Mysql 5.7, React</td>
	</tr>
	<tr>
		<th>프로젝트 개요</th>
		<td>Node.js 프로젝트의 프론트 엔드를 React로 만들어봤습니다.</td>
	</tr>
	<tr>
		<th>Git 주소</th>
		<td>
			<a href='https://github.com/a2175/ReactProject' target='_blank'>https://github.com/a2175/ReactProject</a>
		</td>
	</tr>
	<th>Demo</th>
		<td><a href='http://a2175.iptime.org:3002/'
			target='_blank'>http://a2175.iptime.org:3002/</a></td>
	</tr>
	<tr>
		<th colspan='2' align='center' bgcolor='#CCEEFF' height='20'>상세내용</th>
	</tr>
</table>

<table width='100%' height='1'>
<tr>
<td>

<img src='http://${window.location.hostname}/img/3-4.png' style='width: 50%; height: auto;'>

앞의 Node.js 프로젝트의 프론트 엔드를 React로 구축한 프로젝트입니다.

</td>
</tr>
</table>

</div>
`
